import posthog from 'posthog-js';
import type { EventName, EventProperties } from './eventNames';

/**
 * 手動イベント送信ラッパー（最小セット用）。
 *
 * ⚠️ クリック / ページ遷移 / フォーム submit はここで送らない（Autocapture に任せる）。
 * 使うのは {@link EVENT_NAMES} に定義した手動イベント最小セットのみ。
 *
 * イベント名とプロパティ型は {@link EventProperties} で紐付くため、
 * 未定義イベントや不正なプロパティはコンパイルエラーになる。
 */
export function trackEvent<E extends EventName>(name: E, properties: EventProperties[E]): void {
  // init 前（テスト / KEY 未設定）は送信しない。
  if (!posthog.__loaded) return;
  posthog.capture(name, properties);
}
